"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// custom element needs VDOM
require("../vdom");
require("./style/index");
var component_1 = require("./component");
exports.Component = component_1.Component;
var static_component_1 = require("./static-component");
exports.StaticComponent = static_component_1.StaticComponent;
var attr_1 = require("./decorator/attr");
exports.attr = attr_1.attr;
var component_2 = require("./decorator/component");
exports.component = component_2.component;
var event_1 = require("./decorator/event");
exports.event = event_1.event;
var state_1 = require("./decorator/state");
exports.state = state_1.state;
var context_state_1 = require("./decorator/context-state");
exports.contextState = context_state_1.contextState;
var render_1 = require("./function/render");
exports.render = render_1.render;
//# sourceMappingURL=index.js.map